/**
 * Get the plugin image thumb url
 * @returns {string}
 */
export function getPluginThumbUrl(pluginKey) {
  const key = pluginKey.substring(0, pluginKey.indexOf('/'));
  return `https://koalaboss-app-plugin-images.s3.ap-southeast-2.amazonaws.com/${key}.png`;
}
